import React from "react";

const LanguageSelector = ({ languages = [], className = "", hasWhiteBackground = true }) => {
  if (!languages || languages.length === 0) {
    return null;
  }

  return (
    <div className={`language-selector inline-flex items-center flex-shrink-0 ${className}`}>
      {languages.map((lang, index) => {
        const isActive = lang.current_lang;
        const languageName = lang.name || lang.slug;

        return (
          <React.Fragment key={lang.slug}>
            {index > 0 && (
              <div
                className={`mx-2 w-px h-3 ${
                  hasWhiteBackground ? "bg-gray-400" : "bg-white opacity-40"
                }`}
              />
            )}
            <a
              href={lang.url}
              className={`
                text-sm font-medium transition-colors duration-200 hover:no-underline inline-flex items-center flex-shrink-0
                ${
                  isActive
                    ? "text-muotolevy-red font-semibold"
                    : hasWhiteBackground
                    ? "text-gray-700 hover:text-muotolevy-red"
                    : "text-white hover:text-muotolevy-red"
                }
              `}
              aria-label={`Switch to ${lang.name}`}
              aria-current={isActive ? "page" : undefined}
            >
              {languageName}
            </a>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default LanguageSelector;
